import { createStore } from 'vuex'
import { lang } from '../plugins/utils'
import { getTextData, getAuthInfo, getWalletList, getWalletUserNotifications, getExchangeRates, doExchange } from '../services/api'
import { handleAsyncError } from '../services/errorHandler'


async function refreshWalletList(context) {

  const walletList = await getWalletList(context.state.authToken)
  context.commit("updateWalletList", walletList)

  return walletList
}


const store = createStore({
  state: {
    sendConfirmCode: false,
    phone: '',
    authToken: localStorage.getItem("authToken"),
    walletList: null,  
    authInfo: null,
    textData: null,
    userNotifications: null,
    openSearchAssets: false,
    openSelectAccount: false,
    selectExchangeOpened: false,
    selectExchangeActiveTab: null,
    exchangeFromAccount: null,
    exchangeToAccount: null,
    exchangeRates: null,
    lang: lang,
  },
  getters: {
    textData: (state) => (textId) => {
      if (!textId || !state.textData || !state.textData[textId] || !state.lang) {
        return null;
      }
      return state.textData[textId][state.lang];
    }
  },
  mutations: {
    changeSearchAssets(state, value) {
      state.openSearchAssets = value
    },
    changeSelectAccount(state, value) {
      state.openSelectAccount = value
    },
    selectExchangeActiveTab(state, value) {
      state.selectExchangeActiveTab = value
    },
    changeSelectExchange(state,value) {
      state.selectExchangeOpened = value      
    },    
    logout(state) {
      state.authToken = null
      localStorage.removeItem('authToken')
    },      
    setAuthToken(state, authToken) {
      state.authToken = authToken
      localStorage.setItem('authToken', authToken)
    },
    ConfirmCode(state) {
      state.sendConfirmCode = !state.sendConfirmCode
    },
    changePhoneNumber (state, phone) {
      state.phone = phone
    },
    // API update
    updateWalletList(state, walletList) {
        state.walletList = walletList
    },
    updateAuthInfo(state, authInfo) {
      state.authInfo = authInfo
    },
    updateTextData(state, textData) {
      state.textData = textData
    },
    updateUserNotifications(state, userNotifications) {
      state.userNotifications = userNotifications
      console.log("userNotifications", userNotifications)
    },

    // API Update: exchange
    updateExchangeFromAccount(state, exchangeFromAccount) {
      state.exchangeFromAccount = exchangeFromAccount
    },
    updateExchangeToAccount(state, exchangeToAccount) {
      state.exchangeToAccount = exchangeToAccount
    },
    updateExchangeRates(state, exchangeRates) {
      state.exchangeRates = exchangeRates
    },
  },
  actions: {    
    // API requests
    async refreshWalletList(context) {
      handleAsyncError( 
        context,        
        async function() {
          await refreshWalletList(context)
         }
      ) ()
    },
    async refreshExchangeRates(context) {
      handleAsyncError( 
        context,
        async function() {      
          context.commit("updateExchangeRates", await getExchangeRates(context.state.authToken))  
        }
      ) ()
    },    
    async refreshAuthInfo(context) {
      handleAsyncError( 
        context,
        async function() {      
          context.commit("updateAuthInfo", await getAuthInfo(context.state.authToken))  
        }
      ) ()
    },
    async refreshTextData(context) {
      handleAsyncError( 
        context,
        async function() {      
            context.commit("updateTextData", await getTextData(context.state.authToken))  
        }
      ) ()
    },    
    async refreshUserNotifications(context) {
      handleAsyncError( 
        context,
        async function() {
          context.commit("updateUserNotifications", await getWalletUserNotifications(context.state.authToken))  
        }
      ) ()
    },
    async setDefaultExchangeAccounts(context) {
      handleAsyncError( 
        context,
        async function() {

          const walletList = (
            context.state.walletList === null 
            ? await refreshWalletList(context)
            : context.state.walletList
          )

          if (walletList && walletList.length > 1) {
            const firstAccount = walletList[0];
            const secondAccount = walletList[1];

            context.commit("updateExchangeFromAccount", firstAccount);
            context.commit("updateExchangeToAccount", secondAccount);
          }
        }
      ) ()
    },
    async doExchange(context, payload) {
      return handleAsyncError( 
        context,
        async function() {
          return await doExchange(
            context.state.authToken, 
            payload.from_account_id,
            payload.to_account_id,
            payload.from_amount,
            payload.to_amount,
            payload.rate_id
          )
        }
      ) ()
    }
  },
  modules: {
  }
})

export default store;
